export const CardTypes: any = {
    'AddCards': 'card/addCards',
};